import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PaymentConfirmService } from '../payment-confirm.service';
import { PaymentConfirm } from '../payment-confirm';
import { PaymentConfirmComponent } from '../payment-confirm/payment-confirm.component';
import { ReservationService } from '@app/_components/reservation';
import * as moment from 'moment';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';
import { OrderService } from '@app/_components/order';
import { PropertyService } from '@app/_components/property';

@Component({
    selector: 'app-payment-confirm-list',
    templateUrl: './payment-confirm-list.component.html',
    styleUrls: ['./payment-confirm-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PaymentConfirmListComponent implements OnInit {
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	paymentTypes: any[];
	paymentCreditCardRequests: any[];
	reservationIdIsNull = false;
	paymentConfirmIdNotNull = false;
	invoiceDetailTypes: any[]=[];
	checkInStartDate: Date | null = null;
	checkInEndDate: Date | null = null;
	checkOutStartDate: Date | null = null;
	checkOutEndDate: Date | null = null;
	constructor(
		private paymentConfirmService: PaymentConfirmService,
		private alertService: AlertService,
		private reservationService: ReservationService,
		private messageService: MessageService,
		private orderService: OrderService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private propertyService: PropertyService
	) {
		this.statuses = paymentConfirmService.statuses;
		this.paymentTypes = reservationService.paymentTypes;
		this.paymentCreditCardRequests = reservationService.paymentCreditCardRequests;
		this.invoiceDetailTypes = this.orderService.invoiceDetailTypes;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	paymentConfirms: any;
	paymentConfirm: PaymentConfirm;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];
	properties: any;
	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'reservationVO.shortTermRentalVO.shortTermRentalId', header: 'Property Code', width: 'auto' },
		{ field: 'reservationVO.shortTermRentalVO.addressState', header: 'State', width: 'auto' },
		{ field: 'paymentConfirmVO.paymentProcessDate', header: 'Process Date', width: 'auto' },
		{ field: 'reservationVO.checkInDateTime', header: 'Check-In', width: 'auto' },
		{ field: 'reservationVO.checkOutDateTime', header: 'Check-Out', width: 'auto' },
		{ field: 'reservationVO.guestProfileVO.lastName', header: 'Name', width: 'auto' },
		{ field: 'reservationVO.guestProfileVO.lastName', header: 'Hash Name', width: 'auto' },
		{ field: 'orderInvoiceVO.orderVO.orderId', header: 'order#', width: 'auto' },
		{ field: 'reservationVO.reservationId', header: 'reservation#', width: 'auto' },
		{ field: 'paymentConfirmVO.paymentConfirmId', header: 'paymentConfirm#', width: 'auto' },
		{ field: 'paymentConfirmVO.amount', header: 'Amount', width: 'auto' },
		{ field: 'paymentConfirmVO.paymentProcessAmount', header: 'Process Amount', width: 'auto' },
		{ field: 'paymentConfirmVO.paymentType', header: 'Type', width: 'auto' },
		{ field: 'type', header: 'Trx', width: 'auto' },
		// { field: 'paymentGatewayProvider', header: 'Gateway Provider', width: 'auto' },
		{ field: 'paymentConfirmVO.paymentTransactionConfirmNumber', header: 'Transaction Conf#', width: 'auto' },
		{ field: 'paymentConfirmVO.paymentProceedsDepositedToAccountIdentifier', header: 'Depo Acc Identifier', width: 'auto' },
		{ field: 'paymentConfirmVO.paymentSourceAccountIdentifier', header: 'Src Acc Identifier', width: 'auto' },
		// { field: 'paymentResultIndicator', header: 'Result Indicator', width: 'auto' },
		// { field: 'paymentCreditCardRequestedTransactionType', header: 'CC Req Trs Type', width: 'auto' },
		// { field: 'paymentInvoiceNumber', header: 'Invoice#', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
			this.fetchProperties();
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.paymentConfirmId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-paymentConfirm-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			// if (event.filters["paymentConfirmVO.paymentProcessDate"] && event.filters["paymentConfirmVO.paymentProcessDate"].value) {
			// 				event.filters["paymentConfirmVO.paymentProcessDate"].value = moment(event.filters["paymentConfirmVO.paymentProcessDate"].value).format('MM/DD/YYYY');
			// 			}

			let reservationIdIsNullFilter = { 'reservationIdIsNull': { 'value': this.reservationIdIsNull, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdIsNullFilter);

				let paymentConfirmIdNotNullFilter = { 'paymentConfirmIdNotNull': { 'value': this.paymentConfirmIdNotNull, 'matchMode': 'in' } };
				Object.assign(event.filters, paymentConfirmIdNotNullFilter);

				if (this.checkInStartDate) {
					event.filters['checkInStartDate'] = { value: moment(this.checkInStartDate).format('YYYY-MM-DD'), matchMode: 'in' };
				}
				if (this.checkInEndDate) {
					event.filters['checkInEndDate'] = { value: moment(this.checkInEndDate).format('YYYY-MM-DD'), matchMode: 'in' };
				}
				if (this.checkOutStartDate) {
					event.filters['checkOutStartDate'] = { value: moment(this.checkOutStartDate).format('YYYY-MM-DD'), matchMode: 'in' };
				}
				if (this.checkOutEndDate) {
					event.filters['checkOutEndDate'] = { value: moment(this.checkOutEndDate).format('YYYY-MM-DD'), matchMode: 'in' };
				}



			const pageNumber = Math.round(event.first / event.rows);
			this.paymentConfirmService.findByQueryDSLFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.paymentConfirms = res.data.orderInvoiceDetails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.paymentConfirms = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.propertySummaryIndividualPropertyList()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(paymentConfirm: PaymentConfirm) {
		try {
			this.formLoading = true;
			this.paymentConfirmService.update(paymentConfirm)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.paymentConfirms.map((paymentConfirm, i) => {
							if (paymentConfirm.paymentConfirmId === res.data.paymentConfirm.paymentConfirmId) {
								this.paymentConfirms[i] = res.data.paymentConfirm;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(paymentConfirm: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(paymentConfirm));

			this.formLoading = true;
			this.paymentConfirmService.delete(paymentConfirm.paymentConfirmId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.paymentConfirms.splice(this.paymentConfirms.indexOf(paymentConfirm), 1);
						this.recordTotal = this.paymentConfirms.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PaymentConfirm ' + paymentConfirm.paymentConfirmId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PaymentConfirm ' + paymentConfirm.paymentConfirmId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add PaymentConfirm'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PaymentConfirmComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPaymentConfirmCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(paymentConfirm: PaymentConfirm) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			paymentConfirm: paymentConfirm,
			title: 'Edit PaymentConfirm'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PaymentConfirmComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePaymentConfirmCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePaymentConfirmCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPaymentConfirmCB(paymentConfirm: PaymentConfirm) {
		console.log('Adding PaymentConfirm: ' + JSON.stringify(paymentConfirm));
		// if we don't have a paymentConfirms array yet...
		if (!this.paymentConfirms) {
			this.paymentConfirms = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.paymentConfirms.unshift(paymentConfirm);

		// no idea what this is but it is required to update the array
		this.paymentConfirms = [...this.paymentConfirms];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PaymentConfirm ' + paymentConfirm.paymentConfirmId + ' Added', life: 3000 });
	}

	updatePaymentConfirmCB(paymentConfirm: PaymentConfirm) {
		console.log('Updating PaymentConfirm: ' + JSON.stringify(paymentConfirm));
		let itemIndex = this.paymentConfirms.findIndex((item: any) => item.paymentConfirmId === paymentConfirm.paymentConfirmId);
		this.paymentConfirms[itemIndex] = paymentConfirm;

		// no idea what this is but it is required to update the array
		this.paymentConfirms = [...this.paymentConfirms];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PaymentConfirm ' + paymentConfirm.paymentConfirmId + ' Updated', life: 3000 });
	}

	deletePaymentConfirmCB(paymentConfirm: PaymentConfirm) {
		console.log('Removing PaymentConfirm: ' + paymentConfirm);
		this.paymentConfirms.splice(this.paymentConfirms.indexOf(paymentConfirm), 1);
		this.recordTotal = this.paymentConfirms.length;

		// no idea what this is but it is required to update the array
		this.paymentConfirms = [...this.paymentConfirms];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PaymentConfirm ' + paymentConfirm.paymentConfirmId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.paymentConfirms ? this.first === (this.paymentConfirms.length - this.rows) : true; }
	isFirstPage(): boolean { return this.paymentConfirms ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(paymentConfirm: any) {
		if (paymentConfirm?.status) {
			const status = this.statuses.find((e: any) => e.value == paymentConfirm.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	getPaymentTypeName(paymentConfirm: any) {
		if (paymentConfirm?.paymentType) {
			const status = this.paymentTypes.find((e: any) => e.value == paymentConfirm.paymentType);
			return status?.name != undefined ? status?.name : "";
		}
		else {
			return '';
		}
	}

	getInvoiceDetailTypeName(paymentConfirm: any) {
		if (paymentConfirm?.type) {
			const status = this.invoiceDetailTypes.find((e: any) => e.value == paymentConfirm.type);
			return status?.name != undefined ? status?.name : "";
		}
		else {
			return '';
		}
	}

	getPaymentCreditCardRequestsName(paymentConfirm: any) {
		if (paymentConfirm?.paymentCreditCardRequestedTransactionType) {
			const status = this.paymentCreditCardRequests.find((e: any) => e.value == paymentConfirm.paymentCreditCardRequestedTransactionType);
			return status.name;
		}
		else {
			return '';
		}
	}

	onActiveFilterChange(event: any) {
		this.reservationIdIsNull = event.checked;
		this.loadLazy(this.lazyLoadEvent);
	}

	onActiveFilterChangeForPaymentConfirm(event: any) {
		this.paymentConfirmIdNotNull = event.checked;
		this.loadLazy(this.lazyLoadEvent);
	}

	onCheckInOutDateChange() {
		if (this.lazyLoadEvent) {
			this.loadLazy(this.lazyLoadEvent);
		}
	}

	exportSelected(exporttype: any) {
    this.importExportComponent.exporData(exporttype, this.paymentConfirms, 'Payment Confirms');
	}
}
